<template>
    <div  class="dropdown">
        <div @click.stop="dropdownActive = !dropdownActive" class="dropdown__header">
            <p class="dropdown__title"><slot name="title" /></p>
            <p class="dropdown__text"><slot name="text" /></p>
            <div class="d-flex align-items-center icons-wrapper">
                <div class="icons-inner d-flex align-items-center">
                    <slot name="actions">

                    </slot>                    
                </div>
                <div class="ml-3" :class="{active: dropdownActive}">
                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.46875 8.9375C6.75 9.21875 7.21875 9.21875 7.5 8.9375L13.5938 2.875C13.875 2.5625 13.875 2.09375 13.5938 1.8125L12.875 1.09375C12.5938 0.8125 12.125 0.8125 11.8125 1.09375L7 5.90625L2.15625 1.09375C1.84375 0.8125 1.375 0.8125 1.09375 1.09375L0.375 1.8125C0.09375 2.09375 0.09375 2.5625 0.375 2.875L6.46875 8.9375Z" fill="#7F7F82"/>
                    </svg>
                </div>
            </div>

        </div>
        <transition name="fade">
            <div v-show="dropdownActive" class="dropdown__body mt-4 pt-4">
               <slot></slot>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    data(){
        return {
            dropdownActive: false
        }
    }
}
</script>
<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
.icons-wrapper{
  min-width: 126px;
}
.dropdown{
    padding: 22px 24px;
    background-color: $white;
    border-radius: 12px;
    box-shadow:  0 6px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid $gray-light1;
    margin-bottom: 6px;
    &__text{
        color: $gray-medium
    }
    &__title{
      padding-right: 64px;
    }
    &__header{
        display: flex;
        align-items: center;
        cursor: pointer;
        p{
            width: 50%
        }
    }
    &__body{
        border-top: 1px solid $gray-medium;
    }
}
.fas{
    color: $gray-medium
}
.fade-enter-from{
    opacity: 0;
    height: 0;
}
.fade-enter-to{
    opacity: 1;

}
.fade-enter-active{
    transition: all 0.5s ease;
}
.fade-leave-from{

}
p{
    margin: 0;
}
.icons-inner{
    max-width: 104px;
    width: 100%;
    justify-content: flex-end;
}
.active{
    transform: rotate(180deg);
}

</style>